<template>
  <div class="joinUs">
    <topbar :imp="navText"></topbar>
    <img class="ban" src="./img/ban.jpg">
    <div class="conTitle">加入我们</div>
    <div class="conTitle_bor"></div>
    <div class="hei30"></div>
    <div class="wrap conInto">
      <p>工业互联网平台是工业系统与人工智能、大数据以及互联网的融合产物。它通过成熟的通讯协议，连接海量设备，在云端对设备上传的工业数据进行深度分析和决策，重构工业运营和维护，激发生产力。它能够实现装备的智能化、管理的智能化、服务的智能化、生产的智能化。让工业系统变得更加高效、安全、绿色和无忧。</p>
      <p>上海航数智能科技有限公司是中国工业数字化解决方案供应商，为各类工业设备提供工业互联网平台解决方案，平台的特殊优势是积累了上十年先进的健康管理技术，并将其应用于工业设备的智能化运营。航数智能以中国工业数字化为使命，助力中国制造2025。</p>
      <p>如果您拥有同样的梦想，欢迎您加入我们！</p>
    </div>
    <div class="wrap clear">
      <div class="list fl">
        <img src="./img/list1.jpg">
        <div class="listCon">
          <h6>前端开发工程师</h6>
          <p>移动端，Web端H5开发，编写可复用的用户界面组件，持续的优化前端体验和页面响应速度，并保证兼容性和执行效率...</p>
          <span @click="modalData1 = true">岗位详情>></span>
        </div>
      </div>
      <div class="list fr">
        <img src="./img/list4.png">
        <div class="listCon">
          <h6>大数据运维</h6>
          <p>大数据运维负责大数据平台的基础运维工作，负责大数据平台的应用运维工作，对外提供统一接口，日常运维流程管理...</p>
          <span @click="modalData4 = true">岗位详情>></span>
        </div>
      </div>
      <div class="list fl">
        <img src="./img/list3.jpg">
        <div class="listCon">
          <h6>水泵销售</h6>
          <p>负责水泵的工业物联网的销售工作，包括新客户开发和客户关系维护,负责与用户的技术交流、公司及技术方案宣讲...</p>
          <span @click="modalData3 = true">岗位详情>></span>
        </div>
      </div>
      <div class="list fr">
        <img src="./img/list2.jpg">
        <div class="listCon">
          <h6>机床销售</h6>
          <p>负责加工机床工业物联网的销售工作，包括新客户开发和客户关系维护,负责与用户的技术交流、公司及技术方案宣讲...</p>
          <span @click="modalData2 = true">岗位详情>></span>
        </div>
      </div>
    </div>
    <div class="wrap botInfo">
      应聘职位，投递简历至：hr@hangshutech.com<br>简历投递格式请以“应聘职位+姓名”作为邮件标题
      <div class="modal" v-if="modalData1">
        <div class="close"><img @click="modalData1 = false" src="./img/close.jpg"></div>
        <div class="modalTitle">前端开发工程师</div>
        <h3 class="modalH3">职位描述</h3>
        <p class="modalP">1、移动端，Web端H5开发，编写可复用的用户界面组件；<br>
        2、持续的优化前端体验和页面响应速度，并保证兼容性和执行效率；<br>
        3、负责前端产品的页面制作，根据UI设计图完成html5应用的编码；<br>
        4、配合开发工程师一起研讨技术实现方案，进行应用及系统整合。<br>
        5、测试维护并持续优化现有产品，修复bug，提高前端的用户体验及性能<br>
        6、参与前端工程体系建设。</p>
        <h3 class="modalH3">岗位要求</h3>
        <p class="modalP">1、熟悉HTML5/CSS3标准，精通Javascript前端开发，两年以上的Web应用开发经验，熟悉vue等常见web开发框架中的一种，能快速高效实现各种交互效果；<br>
        2、精通XHTML/XML/CSS、JavaScript、AJAX、Angular、Jquery等，精通W3C标准，熟悉对象化Javascript编程，熟练使用react、react-native、node者优先；<br>
        3、对Android与iOS不同平台的html5页面适配有较好的了解，具有Android、iPhone、iPad等智能手机和平板html5开发经验；<br>
        4、合理优化js / css等代码，使得网站体验更加优越；<br>
        5、熟练使用less或sass进行前端开发，具有良好的编码风格与规范；<br>
        6、良好的逻辑思维和团队合作能力，应聘时附上H5作品的候选人优先；</p>
        <div class="modalBot">应聘职位，投递简历至：hr@hangshutech.com<br>简历投递格式请以“应聘职位+姓名”作为邮件标题</div>
      </div>
      <div class="modal" v-if="modalData2">
        <div class="close"><img @click="modalData2 = false" src="./img/close.jpg"></div>
        <div class="modalTitle">机床销售</div>
        <h3 class="modalH3">职位描述</h3>
        <p class="modalP">1、负责加工机床工业物联网的销售工作，包括新客户开发和客户关系维护；<br>
        2、负责与用户的技术交流、公司及技术方案宣讲、应用系统演示等工作；<br>
        3、根据客户需求和市场变化，对公司的产品提出改进建议；<br>
        4、负责展会、论坛等市场活动的内容安排、客户联络等相关工作；</p>
        <h3 class="modalH3">岗位要求</h3>
        <p class="modalP">1、3年以上加工机床大客户销售或渠道销售经验，有较强的商务谈判和业务拓展能力；<br>
        2、具备良好的沟通能力、书面写作和表达能力，能够应对出差和工作内容多样性等的压力；<br>
        3、加工机床等相关专业大专及以上学历，在业内有丰富的人脉资源；</p>
        <div class="modalBot">应聘职位，投递简历至：hr@hangshutech.com<br>简历投递格式请以“应聘职位+姓名”作为邮件标题</div>
      </div>
      <div class="modal" v-if="modalData3">
        <div class="close"><img @click="modalData3 = false" src="./img/close.jpg"></div>
        <div class="modalTitle">水泵销售</div>
        <h3 class="modalH3">职位描述</h3>
        <p class="modalP">1、负责水泵的工业物联网的销售工作，包括新客户开发和客户关系维护；<br>
        2、负责与用户的技术交流、公司及技术方案宣讲、应用系统演示等工作；<br>
        3、根据客户需求和市场变化，对公司的产品提出改进建议；<br>
        4、负责展会、论坛等市场活动的内容安排、客户联络等相关工作；</p>
        <h3 class="modalH3">岗位要求</h3>
        <p class="modalP">1、3年以上水泵大客户销售或渠道销售经验，有较强的商务谈判和业务拓展能力；<br>
        2、具备良好的沟通能力、书面写作和表达能力，能够应对出差和工作内容多样性等的压力；<br>
        3、水泵等相关专业大专及以上学历，在业内有丰富的人脉资源；</p>
        <div class="modalBot">应聘职位，投递简历至：hr@hangshutech.com<br>简历投递格式请以“应聘职位+姓名”作为邮件标题</div>
      </div>
      <div class="modal" v-if="modalData4">
        <div class="close"><img @click="modalData4 = false" src="./img/close.jpg"></div>
        <div class="modalTitle">大数据运维</div>
        <h3 class="modalH3">职位描述</h3>
        <p class="modalP">1、负责大数据平台的基础运维工作；<br>
        2、负责大数据平台的应用运维工作,对外提供统一接口；<br>
        3、日常运维流程管理；<br>
        4、日常故障跟踪处理。</p>
        <h3 class="modalH3">岗位要求</h3>
        <p class="modalP">1、 2年以上运维工作经验；<br>
        2、掌握Java,hadoop平台搭建与开发，熟悉Linux平台，会Python优先;<br>
        3、能熟练使用互联网公司的常用运维软件， 包括但不限于:nginx/tomcat/zabbix/puppet；<br>
        4、有一定的运维自动化开发经验，对shell/python/perl有1-2门语言使用熟练；<br>
        5、接触过大数据相关应用者优先，包括但不限于：hadoop/zookeeper/hbase/storm/kafka/flume；<br>
        6、良好的团队精神和沟通能力，很强的逻辑思维能力和学习能力;<br>
        7、对工作认真负责，注重细节，肯吃苦，顾全大局。</p>
        <div class="modalBot">应聘职位，投递简历至：hr@hangshutech.com<br>简历投递格式请以“应聘职位+姓名”作为邮件标题</div>
      </div>
    </div>
    <botcon></botcon>
  </div>
</template>

<script>
import Topbar from "@/components/base/Topbar/index";
import Botcon from "@/components/base/Botcon/index";
export default {
  name: "JoinUs",
  components: {
    Topbar,
    Botcon
  },
  data() {
    return {
      modalData1: false,
      modalData2: false,
      modalData3: false,
      modalData4: false,
      navText: {
        text: "加入我们"
      }
    };
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        let r = window.innerWidth - document.body.clientWidth;
        this.$store.commit("setScroll", r);
      }, 20);
    });
    this.menu();
  },
  methods: {
    menu() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ban {
  display: block;
  width: 100%;
  height: auto;
}
.conTitle {
  height: 180px;
  text-align: center;
  font-size: 50px;
  line-height: 52px;
  padding-top: 89px;
  color: #3e3e3e;
}
.conTitle_bor {
  width: 90px;
  height: 1px;
  margin: 0 auto;
  background: #ccc;
}
.hei30 {
  width: 100%;
  height: 30px;
}
.conInto {
  background: #eef0f5;
  padding: 20px 120px 0;
  font-size: 21px;
  color: #5e5e5e;
  line-height: 39px;
}
.conInto p {
  padding: 20px 0 40px 0;
}

.list {
  width: 576px;
  height: 239px;
  padding: 26px 17px;
  margin-top: 65px;
  border: #e0dfe0 solid 1px;
  display: flex;
}
.list img {
  width: 192px;
  height: 192px;
  margin-right: 17px;
}
.listCon {
  flex: 1;
}
.listCon h6 {
  width: 100%;
  height: 40px;
  font-size: 18px;
  color: #0f376b;
  line-height: 20px;
  padding-bottom: 20px;
}
.listCon p {
  width: 100%;
  font-size: 18px;
  color: #5e5e5e;
  line-height: 26px;
  padding: 0px 0 40px;
}
.listCon span {
  display: block;
  width: 100%;
  font-size: 18px;
  color: #444;
}

.botInfo {
  height: 160px;
  padding-top: 63px;
  font-size: 18px;
  color: #5e5e5e;
  line-height: 24px;
  position: relative;
}

.modal {
  width: 1086px;
  height: auto;
  position: absolute;
  left: 57px;
  bottom: 20px;
  z-index: 3;
  background: #fff;
  box-shadow: 0 0 4px 3px rgba(114, 114, 115, 0.4);
}
.close {
  width: 100%;
  height: 36px;
  padding: 16px 20px 0 0;
  text-align: right;
}
.close img {
  width: 20px;
  height: 20px;
}
.modalTitle {
  margin: 0 94px 0 94px;
  height: 49px;
  border-bottom: #cccbcc solid 1px;
  font-size: 22px;
  color: #0f376b;
  line-height: 30px;
}
.modalH3 {
  font-size: 22px;
  color: #3e3e3e;
  line-height: 24px;
  padding: 30px 94px 16px;
}
.modalP {
  padding: 0 94px;
  font-size: 18px;
  color: #5e5e5e;
  line-height: 32px;
}
.modalBot {
  height: 140px;
  padding: 63px 94px 0;
  font-size: 18px;
  color: #5e5e5e;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/JoinUs/index.vue